import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background py-16">
      <div className="container">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <Logo />
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
              Automatische Instagram Stories für bayerische Amateurfußball-Vereine.
            </p>
          </div>

          {/* Produkt */}
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-foreground">Produkt</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link to="/registrieren" className="hover:text-foreground transition-colors">Verein anmelden</Link></li>
              <li><Link to="/anmelden" className="hover:text-foreground transition-colors">Anmelden</Link></li>
              <li><a href="#how-it-works" className="hover:text-foreground transition-colors">So funktioniert's</a></li>
              <li><a href="#faq" className="hover:text-foreground transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Unternehmen */}
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-foreground">Unternehmen</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><a href="mailto:info@torflash.de" className="hover:text-foreground transition-colors">Kontakt</a></li>
              <li><a href="mailto:info@torflash.de" className="hover:text-foreground transition-colors">info@torflash.de</a></li>
            </ul>
          </div>

          {/* Rechtliches */}
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-foreground">Rechtliches</h4>
            <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
              <li><Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link></li>
              <li><Link to="/agb" className="hover:text-foreground transition-colors">AGB</Link></li>
              <li><Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link></li>
            </ul>
          </div>
        </div>

        <p className="mt-10 max-w-4xl text-xs leading-relaxed text-muted-foreground">
          Beispielgrafiken mit erfundenen Vereinsdaten. Vereinsnamen und Wappen dienen ausschließlich der Veranschaulichung.
        </p>

        <div className="mt-14 border-t border-border/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Torflash</p>
          <p className="text-xs text-muted-foreground">Torflash ist nicht offiziell mit dem BFV verbunden</p>
        </div>
      </div>
    </footer>
  );
}
